import { useFloating, offset, flip, shift, arrow, autoUpdate } from '@floating-ui/react-dom';
import { useRef, useEffect } from 'react';

function usePosition(props) {
  const arrowRef = useRef(null);
  const floating = useFloating({
    strategy: "fixed",
    open: props.active,
    placement: props.placement ?? "bottom-end",
    whileElementsMounted: autoUpdate,
    middleware: [offset(props.offsetPx ?? 10), flip({
      padding: 15
    }), shift({
      padding: 15
    }), arrow({
      element: arrowRef
    })]
  });
  useEffect(() => {
    floating.refs.setReference(props.triggerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [floating.refs, props.triggerRef.current]);
  return {
    floating,
    arrowRef
  };
}

export { usePosition };
//# sourceMappingURL=hook.position.js.map
